/**
 * The `discount.*` capabilities (CAPABILITIES.md §3.4). Ids from the cart contract (P0 step 12);
 * policies in C1, with the discount v2 flow (N23), hidden until then.
 */
import { definePolicies } from "../engine";
import type { OrderResource } from "./order";

declare module "../types" {
  interface CapabilityMap {
    /** open the deals board: deals, coupons and partner offers */
    "discount.apply": OrderResource;
    /** ask a manager to approve the order's discount */
    "discount.requestApproval": OrderResource;
  }
}

export const DISCOUNT_POLICIES = definePolicies("discount", []);
